/**
 * UserName component
 * Fetches and displays a user's name from their ID
 */

import { useUser } from '@/hooks/useUsers';

interface UserNameProps {
  userId: number;
}

export function UserName({ userId }: UserNameProps) {
  const { data: user, isLoading, error } = useUser(userId);

  if (isLoading) {
    return <span className="text-gray-500">...</span>;
  }

  if (error || !user) {
    return <span className="text-gray-500">?</span>;
  }

  return <span>{user.name}</span>;
}
